import React from "react";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Field, useFormik } from "formik";
import * as Yup from "yup";
import Arrowdown from "../../../assets/Card/fi_chevron-down.png";
import { addTripStyles } from "../../UI/styles/Main";
import Navbar2 from "../../LayoutComponents/Navbar/Navbar2";
import { useGetDriverManagementSearchDashboardQuery } from "../../../Api/apiSlice";
import { useAddTripMutation } from "../../../Api/apiSlice";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import CustomAlert from "../../UI/CustomAlert";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const validationSchema = Yup.object({
  // tripId: Yup.string().required("Trip ID is required"),
  // vehicle: Yup.string().required("Vehicle is required"),
  // driverName: Yup.string().required("Driver's Name is required"),
  startLocation: Yup.string().required("Start Location is required"),
  endLocation: Yup.string().required("End Location is required"),
  status: Yup.string().required("Status is required"),
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}
function AddTrip() {
  var search = "";
  var status = "";
  const [addTrip] = useAddTripMutation();
  const { data, error, isLoading } = useGetDriverManagementSearchDashboardQuery(
    { search, status }
  );

  // For mui:
  const theme = useTheme();
  const [tripStart, setTripStart] = useState(null);
  // Selected driver state
  const [selectedDriver, setSelectedDriver] = useState({
    id: "",
    name: "",
  });
  console.log("first driver", selectedDriver);

  // Handle selection change
  // Handle selection change
  const handleChange = (event) => {
    const selectedDriverId = event.target.value;

    // Find the driver's name based on their id
    const driver = data?.drivers.find((d) => d.id === selectedDriverId);

    if (driver) {
      setSelectedDriver({
        id: driver.id,
        name: driver.name,
      });
    }
  };
  //mui

  const [alert, setAlert] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const handleAlertClose = () => {
    setAlert({ ...alert, open: false });
  };

  const handleRegister = async (values, resetForm) => {
    console.log("Form Values: ", values);
    const { startLocation, endLocation, status } = values;
    const tripData = {
      startLocation,
      endLocation,
      status,
      assignedToUserId: selectedDriver.id || null,
      tripStart: tripStart ? dayjs(tripStart).format("YYYY-MM-DD") : null,
    };

    // console.log("here is the trip data ", tripData);
    try {
      await addTrip(tripData).unwrap();

      setAlert({
        open: true,
        severity: "success",
        message: "Trip added successfully",
      });
      resetForm();
    } catch (err) {
      setAlert({
        open: true,
        severity: "error",
        message: "Trip not added",
      });
      console.error("Add Trip failed", err);
    }
  };

  const formik = useFormik({
    initialValues: {
      // tripId: "",
      vehicle: "",
      driverName: "",
      startLocation: "",
      endLocation: "",
      status: "active",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      handleRegister(values, resetForm);
    },
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Paper sx={addTripStyles.mainContainer}>
        <Navbar2 />
        <Box
          sx={addTripStyles.container}
          pl={3}
          mb={3}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Box>
            {/* Start Location Field */}
            <Box sx={addTripStyles.containerItemWidth}>
              <Typography
                variant="subtitle1"
                mt={3}
                mb={1}
                style={addTripStyles.label}
              >
                Start Location
              </Typography>
              <TextField
                placeholder="Select Starting Location"
                variant="outlined"
                size="small"
                name="startLocation"
                value={formik.values.startLocation}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.startLocation &&
                  Boolean(formik.errors.startLocation)
                }
                helperText={
                  formik.touched.startLocation && formik.errors.startLocation
                }
                // InputProps={{
                //   endAdornment: (
                //     <InputAdornment position="end" sx={{ marginRight: 0 }}>
                //       <IconButton sx={{ padding: 0 }}>
                //         <img
                //           src={Arrowdown}
                //           height={"16px"}
                //           width={"20px"}
                //           alt="Arrow Icon"
                //         />
                //       </IconButton>
                //     </InputAdornment>
                //   ),
                // }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "50px",
                    marginLeft: "5px",
                  },
                  width: {
                    xs: "90%",
                    sm: "90%",
                    lg: "36%",
                  },
                }}
              />
            </Box>

            {/* End Location Field */}
            <Box sx={addTripStyles.containerItemWidth}>
              <Typography
                variant="subtitle1"
                mt={3}
                mb={1}
                style={addTripStyles.label}
              >
                End Location
              </Typography>
              <TextField
                placeholder="Select Ending Location"
                variant="outlined"
                size="small"
                name="endLocation"
                value={formik.values.endLocation}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.endLocation &&
                  Boolean(formik.errors.endLocation)
                }
                helperText={
                  formik.touched.endLocation && formik.errors.endLocation
                }
                // InputProps={{
                //   endAdornment: (
                //     <InputAdornment position="end" sx={{ marginRight: 0 }}>
                //       <IconButton sx={{ padding: 0 }}>
                //         <img
                //           src={Arrowdown}
                //           height={"16px"}
                //           width={"20px"}
                //           alt="Arrow Icon"
                //         />
                //       </IconButton>
                //     </InputAdornment>
                //   ),
                // }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "50px",
                    marginLeft: "5px",
                  },
                  width: {
                    xs: "90%",
                    sm: "90%",
                    lg: "36%",
                  },
                }}
              />
            </Box>

            <Box sx={addTripStyles.containerItemWidth}>
              <Typography
                variant="subtitle1"
                mt={3}
                mb={1}
                style={addTripStyles.label}
              >
                Status
              </Typography>
              <FormControl fullWidth>
                {/* <InputLabel>Select Status</InputLabel> */}
                <Select
                  variant="outlined"
                  size="medium"
                  name="status"
                  value={formik.values.status}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.status && Boolean(formik.errors.status)}
                  helperText={formik.touched.status && formik.errors.status}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "50px",
                      marginLeft: "5px",
                    },
                    width: {
                      xs: "90%",
                      sm: "90%",
                      lg: "36%",
                    },
                  }}
                >
                  <MenuItem value="upcoming">upcoming</MenuItem>
                  <MenuItem value="active">active</MenuItem>
                  <MenuItem value="delayed">delayed</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={addTripStyles.containerItemWidth}>
              <Typography
                variant="subtitle1"
                mt={3}
                mb={1}
                style={addTripStyles.label}
              >
                Select Driver
              </Typography>
              <FormControl
                sx={{
                  "& .MuiInputBase-root": {
                    height: "50px",
                    marginLeft: "5px",
                  },
                  width: {
                    xs: "90%",
                    sm: "90%",
                    lg: "36%",
                  },
                }}
              >
                <Select
                  displayEmpty
                  value={selectedDriver.id}
                  onChange={handleChange}
                  input={<OutlinedInput />}
                  renderValue={(selected) => {
                    if (!selected) {
                      return <em>Drivers</em>;
                    }
                    return selectedDriver.name; // Display the selected name
                  }}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem disabled value="">
                    <em>Drivers</em>
                  </MenuItem>
                  {isLoading
                    ? "Loading..."
                    : data?.drivers.map((driver) => (
                        <MenuItem
                          key={driver.id}
                          value={driver.id} // Set the value as the driver's id
                          style={getStyles(
                            driver.name,
                            selectedDriver.name,
                            theme
                          )}
                        >
                          {driver.name}
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>
            </Box>
            <Typography
              variant="subtitle1"
              mt={3}
              mb={1}
              style={addTripStyles.label}
            >
              Select Start Date
            </Typography>
            <Box sx={addTripStyles.containerItemWidth}>
              <Box
                sx={{
                  "& .MuiInputBase-root": {
                    height: "50px",
                    marginLeft: "5px",
                  },
                  width: {
                    xs: "90%",
                    sm: "90%",
                    lg: "36%",
                  },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <DatePicker
                    label="Trip Start Date"
                    value={tripStart}
                    onChange={(newValue) => setTripStart(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        sx={{
                          marginBottom: "16px",
                          width: "100%",
                        }}
                      />
                    )}
                    disablePast
                  />
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Add Button */}
          <Stack sx={{ gap: "24px" }} mt={6} ml={1}>
            <Button
              type="submit"
              variant="contained"
              sx={addTripStyles.button}
              // onClick={handleRegister}
            >
              Add
            </Button>
            <CustomAlert
              open={alert.open}
              onClose={handleAlertClose}
              severity={alert.severity}
              message={alert.message}
            />
          </Stack>
        </Box>
      </Paper>
    </LocalizationProvider>
  );
}

export default AddTrip;
